import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'toggle-usage',
  templateUrl: './toggle-usage.component.html',
  styleUrls: ['./toggle-usage.component.sass']
})
export class ToggleUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
